
export enum PassPrintFormat {
  PassSticker = 'PassSticker',
  NarrowPass = 'NarrowPass',
}
